import React, { useState } from 'react'
import FamilyTitles from "../../data/FamilyTitles";

const HeaderTitle = ({ onModalOpen, title }) => {
    const [showTooltip, setShowTooltip] = useState(false)

    return (
        <div className="relative">
            <h1
                className="text-title-12 sm:text-title-sm lg:text-title-lg font-bold text-[#8B5E3C] font-heebo text-center"
                onClick={onModalOpen}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            >
               <FamilyTitles />
            </h1>
        </div>
    )
}

export default HeaderTitle



